import { emailValidator, Logo } from "uikit"
import TermsofUse from "components/TermsofUse"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Checkbox, Form, Grid, Message } from "semantic-ui-react"
import { useStore } from "store"
import "./Signin.css"
import { v4 as uuidv4 } from "uuid"

class SigninForm extends React.Component {
  state = {
    isPending: false,
    nextStep: null,
    error: null,
    email: "",
    password: "",
    mfaCode: "",
    token: "",
    succeeded: false,
    submitted: false,
    rememberEmail: false,
    rememberDevice: false,
    isEmailFocused: false,
    mfaAttemps: 0,
    countdown: 300
  }

  constructor(props) {
    super(props)
    // if (window.location.pathname === "/signout") window.location.pathname = "/"
    this.state.nextStep = props.signinState && props.signinState.next_step
    this.state.token = props.signinState && props.signinState.token
    this.state.email = window.localStorage.getItem("userEmail") || ""
    this.state.rememberEmail = !!window.localStorage.getItem("userEmail")
    this.state.rememberDevice = !!window.localStorage.getItem("deviceUuid")
    this.state.error =
      props.signinState && props.signinState.error
        ? {
            fields: {
              email: props.signinState.message
            }
          }
        : null
  }

  componentDidUpdate = prevProps => {
    const { signinState: prevSigninState } = prevProps
    const { signinState } = this.props
    const previousNextStep = prevSigninState && prevSigninState.next_step
    const previousExternalProviderDescription =
      prevSigninState && prevSigninState.description
    const previousNextUrl = prevSigninState && prevSigninState.next_url
    const currentNextStep = signinState && signinState.next_step
    const currentExternalProviderDescription =
      signinState && signinState.description
    const currentNextUrl = signinState && signinState.next_url
    if (previousNextStep !== currentNextStep) {
      this.setState({ nextStep: currentNextStep })
    }
    if (
      previousExternalProviderDescription !== currentExternalProviderDescription
    ) {
      this.setState({
        externalProviderDescription: currentExternalProviderDescription
      })
    }

    if (previousNextUrl !== currentNextUrl) {
      this.setState({ nextUrl: currentNextUrl })
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  onSubmit = async () => {
    try {
      const { email, password, mfaCode } = this.state
      if (!mfaCode && !emailValidator(email)) {
        this.setState({
          error: {
            fields: {
              email: "This field must be a valid e-mail"
            }
          },
          submitted: true
        })
      } else {
        this.setState({
          error: {
            fields: {
              email: null
            }
          },
          submitted: true
        })
        if (!this.state.nextStep) {
          const response = await this.props.actions.initiateSignin(email)
          if (response.error) {
            this.setState({
              error: response.error,
              submitted: true
            })
          } else {
            this.setState({ nextStep: response.next_step })
          }
          this.setState({ isPending: false })
        } else if (this.state.nextStep === "password") {
          if (!password || password === "") {
            this.setState({
              error: {
                fields: {
                  password: `This field is required.`
                }
              },
              submitted: true
            })
          } else {
            this.setState({
              error: {
                fields: {
                  password: null
                }
              },
              submitted: true
            })

            this.setState({ isPending: true })
            const cc = await this.props.submit({
              email,
              password
            })

            if (cc.error) {
              this.setErrorState(cc.error)
            } else if (cc.next_step === "finalize") {
              this.props.actions.loadNewAgreements()
            } else {
              this.setState({
                showPassword: false,
                isPending: false,
                nextStep: cc.next_step,
                token: cc.next_url.split("signins/")[1].split("/security")[0]
              })
            }
          }
        } else if (this.state.nextStep === "security-code") {
          this.setState({ isPending: true })
          const resp = await this.props.validateMfa({
            mfaCode: mfaCode.split("-").join(""),
            token: this.state.token
          })
          if (resp.error) {
            this.setState(current => ({ mfaAttemps: current.mfaAttemps + 1 }))
            if (this.state.mfaAttemps === 3) {
              this.interval = setInterval(() => {
                this.setState(current => ({ countdown: current.countdown - 1 }))
                if (this.state.countdown === 0) {
                  clearInterval(this.interval)
                }
              }, 1000)
            }
            this.setErrorState(resp.error)
          } else {
            this.props.actions.loadNewAgreements()
          }
        }
      }
    } catch (er) {
      this.setState({ isPending: false, submitted: true })
      alert("Network Error")
    }
  }

  setErrorState = error =>
    this.setState({
      error: error,
      isPending: false,
      submitted: true
    })

  onEmailClick = async () => {
    await this.props.actions.resetSignIn()
    if (this.state.isEmailFocused) {
      this.moveEmailCaretAtEnd()
    }
    this.setState({ isEmailFocused: false })
  }

  moveEmailCaretAtEnd = () => {
    var temp_value = this.state.email
    this.setState({ email: "" })
    this.setState({ email: temp_value })
  }

  render = () => {
    const {
      isPending,
      nextStep,
      nextUrl,
      error,
      externalProviderDescription
    } = this.state
    const showPassword = nextStep === "password"

    return (
      <Grid className="Signin" data-testid="signin">
        <Grid.Row>
          <Grid.Column textAlign="right">
            <div style={{ display: "inline-block" }}>
              <a href="https://www.savvifi.com" className="Signin__Link">
                About Us
              </a>
              <span className="Signin__Link">
                <TermsofUse />
              </span>
              <a href="https://help.savvifi.com" className="Signin__Link">
                Help
              </a>
              {/*}
              <Link to="/signup">
                <Button className="Signin__SignupButton" data-testid="signup">
                  Sign Up
                </Button>
                </Link>*/}
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row verticalAlign="top">
          <Grid.Column textAlign="center">
            <Grid className="Signin__Grid">
              <Grid.Row columns="equal">
                <Grid.Column textAlign="center">
                  <Form onSubmit={this.onSubmit} error={!!error}>
                    <Grid className="Signin__Div">
                      <Grid.Row
                        verticalAlign="middle"
                        style={{ margin: "2em 0em 2em 0em" }}
                      >
                        <Grid.Column textAlign="center">
                          <Logo />
                        </Grid.Column>
                      </Grid.Row>
                      {nextStep && nextStep === "security-code" ? (
                        <Grid.Row style={{ paddingTop: "0" }}>
                          <Grid.Column style={{ padding: "0 3rem 0 3rem" }}>
                            <p style={{ textAlign: "left" }}>
                              Please enter the verification code that has been
                              sent to you by SMS text message (or a backup
                              code).
                            </p>
                            <Form.Input
                              fluid
                              autoFocus={true}
                              onChange={({ target: { value } }) =>
                                this.setState({
                                  mfaCode: value,
                                  error: {
                                    fields: {
                                      mfaCode:
                                        value && value !== ""
                                          ? null
                                          : "This field is required."
                                    }
                                  }
                                })
                              }
                              value={this.state.mfaCode}
                              error={!!(error && error.fields.mfaCode)}
                              className="Signin__FormInput"
                              icon="lock"
                              iconPosition="left"
                              type="text"
                              autoComplete="off"
                              placeholder="Verification Code"
                              data-testid="mfaCode"
                              disabled={isPending}
                            />
                            {error && error.fields.mfaCode ? (
                              this.state.mfaAttemps > 0 ? (
                                <Message
                                  error
                                  content={
                                    this.state.mfaAttemps < 3
                                      ? `Please try again (${3 -
                                          this.state
                                            .mfaAttemps} attempts remaining)`
                                      : `You have exceeded the number of allowable attempts. Wait ${this.state.countdown} secs to request a new code.`
                                  }
                                />
                              ) : (
                                <Message error content={error.fields.mfaCode} />
                              )
                            ) : null}
                          </Grid.Column>
                        </Grid.Row>
                      ) : (
                        <Grid.Row>
                          <Grid.Column style={{ padding: "0 3rem 0 3rem" }}>
                            <Form.Input
                              fluid
                              onChange={({ target: { value } }) =>
                                this.setState({
                                  email: value,
                                  error: {
                                    fields: {
                                      email:
                                        value &&
                                        value !== "" &&
                                        !emailValidator(value) &&
                                        this.state.submitted &&
                                        "This field is required."
                                    }
                                  }
                                })
                              }
                              value={this.state.email}
                              onFocus={() =>
                                this.setState({ isEmailFocused: true })
                              }
                              onClick={this.onEmailClick}
                              error={
                                !!(error && error.fields.email) ||
                                (error && error.fields.email === "")
                              }
                              className="Signin__FormInput"
                              icon="user"
                              iconPosition="left"
                              placeholder="Your email address"
                              data-testid="email"
                              disabled={isPending}
                              readOnly={showPassword}
                              autoFocus={!showPassword}
                            />
                            {error &&
                            error.fields.email &&
                            error.fields.email !== "" ? (
                              <Message error content={error.fields.email} />
                            ) : null}
                          </Grid.Column>
                        </Grid.Row>
                      )}
                      {showPassword ? (
                        <Grid.Row style={{ paddingTop: "0" }}>
                          <Grid.Column style={{ padding: "0 3rem 0 3rem" }}>
                            <Form.Input
                              fluid
                              autoFocus={showPassword}
                              onChange={({ target: { value } }) =>
                                this.setState({
                                  password: value,
                                  error: {
                                    fields: {
                                      password:
                                        value && value !== ""
                                          ? null
                                          : "This field is required."
                                    }
                                  }
                                })
                              }
                              value={this.state.password}
                              error={!!(error && error.fields.password)}
                              className="Signin__FormInput"
                              icon="lock"
                              iconPosition="left"
                              type="password"
                              placeholder="Your password"
                              data-testid="password"
                              disabled={isPending}
                            />
                            {error && error.fields.password ? (
                              <Message error content={error.fields.password} />
                            ) : null}
                          </Grid.Column>
                        </Grid.Row>
                      ) : null}
                      <Grid.Row columns="equal" style={{ padding: "0px" }}>
                        {showPassword ? (
                          <Grid.Column
                            textAlign="right"
                            style={{ paddingRight: "3.1em" }}
                          >
                            <Link
                              style={{ color: "#0caae9", fontWeight: "400" }}
                              to={
                                this.state.email
                                  ? `/reset?email=${encodeURIComponent(
                                      this.state.email
                                    )}`
                                  : "/reset"
                              }
                            >
                              Forgot?
                            </Link>
                          </Grid.Column>
                        ) : (
                          <Grid.Column
                            textAlign="left"
                            style={{
                              paddingLeft: "3.1em",
                              marginBottom: "1em"
                            }}
                          >
                            {nextStep && nextStep === "security-code" ? (
                              this.state.mfaAttemps < 3 && (
                                <Checkbox
                                  label="Remember and trust this browser for 30 days"
                                  checked={this.state.rememberDevice}
                                  onChange={(_, { checked }) => {
                                    if (checked) {
                                      window.localStorage.setItem(
                                        "deviceUuid",
                                        uuidv4()
                                      )
                                    } else {
                                      window.localStorage.removeItem(
                                        "deviceUuid"
                                      )
                                    }
                                    this.setState({ rememberDevice: checked })
                                  }}
                                  data-testid="remember-device"
                                />
                              )
                            ) : (
                              <Checkbox
                                label="Remember me"
                                checked={this.state.rememberEmail}
                                onChange={(_, { checked }) => {
                                  if (checked) {
                                    if (this.state.email) {
                                      window.localStorage.setItem(
                                        "userEmail",
                                        this.state.email
                                      )
                                    }
                                  } else {
                                    window.localStorage.removeItem("userEmail")
                                  }
                                  this.setState({ rememberEmail: checked })
                                }}
                              />
                            )}
                          </Grid.Column>
                        )}
                      </Grid.Row>
                      {this.state.mfaAttemps < 3 ? (
                        <Grid.Row>
                          <Grid.Column>
                            {nextStep && nextStep !== "password" ? (
                              <a href={nextUrl}>
                                {nextStep === "passwordless" ? (
                                  <Button
                                    type="button"
                                    primary
                                    disabled={isPending}
                                    data-testid="signIn"
                                  >
                                    Sign in with{" "}
                                    {externalProviderDescription ||
                                      "External Provider"}
                                  </Button>
                                ) : (
                                  <Button
                                    type="submit"
                                    primary
                                    disabled={isPending}
                                    data-testid="signIn"
                                  >
                                    Verify
                                  </Button>
                                )}
                              </a>
                            ) : (
                              <Button
                                type="submit"
                                primary
                                loading={isPending}
                                disabled={isPending}
                                data-testid="signIn"
                              >
                                {showPassword ? "Sign In" : "Continue"}
                              </Button>
                            )}
                          </Grid.Column>
                        </Grid.Row>
                      ) : (
                        <Grid.Row>
                          <Grid.Column>
                            <Button
                              color="red"
                              onClick={e => {
                                e.preventDefault()
                                clearInterval(this.interval)
                                this.setState({
                                  nextStep: null,
                                  mfaAttemps: 0,
                                  countdown: 300,
                                  mfaCode: ""
                                })
                                this.props.actions.resetSignIn()
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              primary
                              disabled={this.state.countdown > 0}
                              onClick={async e => {
                                e.preventDefault()
                                const resp = await this.props.resendSecurityCode(
                                  this.state.token
                                )
                                if (resp)
                                  this.setState({
                                    mfaAttemps: 0,
                                    mfaCode: "",
                                    error: null,
                                    countdown: 300
                                  })
                              }}
                            >
                              Resend Code
                            </Button>
                          </Grid.Column>
                        </Grid.Row>
                      )}
                    </Grid>
                  </Form>
                </Grid.Column>
                <Grid.Column
                  className="Signin_Definitions"
                  textAlign="center"
                  style={{ borderLeft: "1px solid #d7d7d7" }}
                >
                  <div className="Marketing_Title">sav·vy</div>
                  <div className="Marketing_Heading">/'savē/</div>
                  <div className="Marketing_Section">
                    <div className="Marketing_SectionTitle">informal</div>
                    <ul className="Signin__List">
                      <li>1. shrewdness and practical knowledge... </li>
                      <li>2. the ability to make good judgements... </li>
                      <li>3. to know or understand... </li>
                    </ul>
                  </div>
                  <div className="Marketing_SubTitle">sav·vi fi·nan·cial</div>
                  <div className="Marketing_Heading">
                    /'savē/ /fə`nan(t)SHəl/
                  </div>
                  <div className="Marketing_Section">
                    <span className="Marketing_SectionTitle">
                      wisdom applied
                    </span>
                    <ul className="Signin__List" style={{ color: "#00b5ed" }}>
                      <li>... how your money works</li>
                      <li>... how to spend, save, invest and protect</li>
                      <li>... how to keep more and meet your goals</li>
                    </ul>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const Signin = ({ submit, validateMfa, signinState, resendSecurityCode }) => {
  const actions = useStore()
  const [userState] = useStore("user")
  const signInProp = signinState ? { signinState } : {}
  return (
    <SigninForm
      {...userState}
      {...signInProp}
      actions={actions}
      submit={submit}
      validateMfa={validateMfa}
      resendSecurityCode={resendSecurityCode}
    />
  )
}

export default Signin
